import { ScrollView, SxProp, View, SafeAreaView } from 'dripsy';

import React from 'react';
import { PageContainer } from '../../components/page/PageContainer';
import { PageItem } from '../../components/page/PageItem';
import { H5, TextBody } from '@/design-system/components/typography';
import { ActivityHistoryFilter } from '../../components/activityHistory/ActivityHistoryFilter';
import { ActivityHistoryTab } from '../../components/activityHistory/ActivityHistoryTab';
import { ActivityHistoryProps } from './ActivityHistory.screen';
import { Icon } from '@/design-system/components/icons/Icon';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../components/page/PageHeader';
import { EarnTabRoutes } from '../../earn.navigator';
import { useEarnPageNavigator } from '../../utils/useEarnPageNavigator';
import { PageItemSkeleton } from '../../components/PageItemSkeleton';

export const ActivityHistoryWeb: React.FC<ActivityHistoryProps> = (props) => {
  const { t } = useTranslation();
  const { data } = useEarnPageNavigator();

  return (
    <SafeAreaView sx={{ flex: 1 }}>
      <ScrollView showsVerticalScrollIndicator={false} contentContainerSx={{ flex: 1 }} sx={styles.scrollView}>
        <PageContainer sx={styles.container}>
          <PageHeader data={data} currentPage={EarnTabRoutes.History} title={t('earn-invest::glossary.earn-and-invest')} />
          <PageItem sx={styles.pageItem}>
            <H5 bold>{t('earn-invest::glossary.activity-history')}</H5>
            <View sx={styles.space} />
            <ActivityHistoryFilter categoriesFilters={props.categoriesFilters} onFilterChange={props.onFilterChange} />
            {/* Table */}
            <View sx={{ flex: 1, overflowX: 'hidden', gap: '$8' }}>
              {props.loading && props.subscriptions.length === 0 && (
                <View sx={{ mt: '$8' }}>
                  <PageItemSkeleton />
                </View>
              )}
              {!props.loading && props.subscriptions.length === 0 && (
                <View sx={{ paddingY: '$20', justifyContent: 'center', alignItems: 'center', gap: '$2' }}>
                  <Icon name="listZeroState" height={60} width={60} />
                  <View sx={{ height: '$4' }} />
                  <TextBody secondary>{t('earn-invest::glossary.no-activity-currently')}</TextBody>
                  <View sx={{ height: '$5' }} />
                </View>
              )}
              {props.subscriptions.length > 0 && <ActivityHistoryTab {...props} />}
            </View>
          </PageItem>
        </PageContainer>
      </ScrollView>
    </SafeAreaView>
  );
};

enum StyleName {
  scrollView = 'scrollView',
  container = 'container',
  pageHeader = 'pageHeader',
  pageItem = 'pageItem',
  space = 'space'
}

const styles: Record<StyleName, SxProp> = {
  scrollView: {
    height: '100%',
    backgroundColor: 'transparent'
  },
  container: {
    paddingX: '$10',
    paddingY: '$10',
    backgroundColor: 'transparent'
  },
  pageHeader: {
    mb: '$6'
  },
  pageItem: {
    borderRadius: 15,
    padding: '$7'
  },
  space: {
    height: '$10'
  }
};
